module.exports = __webpack_public_path__ + "static/media/results.1aa092d2.jpg";